/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {ApiConfig} from '../config/api-config';

@Injectable({providedIn: 'root'})
export class NetworkForecastApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  get(): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri('networkforecast'),
      params: {}
    });
  }
}
